// 現在開いているページのURLを取得
function getCurrentPageUrl(){
  // urlを取得
  var locationUrl = location.href;

  // check current Lang
  var langList = {
      'ko':'https://hi.mu-mo.com/ko',
      'zh-hant':'https://hi.mu-mo.com/zh-hant',
      'zh':'https://hi.mu-mo.com/zh',
      'en':'https://hi.mu-mo.com/en',
      'fr':'https://hi.mu-mo.com/fr',
      'ja':'https://hi.mu-mo.com/'
  };

  // page URL
  var locationPageUrl = '';

  if( locationUrl.indexOf( langList['ko'] ) != -1 ){
    locationPageUrl = locationUrl.split( langList['ko'] )[1].split("?")[0];

  } else if( locationUrl.indexOf( langList['zh-hant'] ) != -1 ){
    locationPageUrl = locationUrl.split( langList['zh-hant'] )[1].split("?")[0];

  } else if( locationUrl.indexOf( langList['zh'] ) != -1 ){
    locationPageUrl = locationUrl.split( langList['zh'] )[1].split("?")[0];

  } else if( locationUrl.indexOf( langList['en'] ) != -1 ){
    locationPageUrl = locationUrl.split( langList['en'] )[1].split("?")[0];

  } else if( locationUrl.indexOf( langList['fr'] ) != -1 ){
    locationPageUrl = locationUrl.split( langList['fr'] )[1].split("?")[0];

  } else if( locationUrl.indexOf( langList['ja'] ) != -1 ){
    locationPageUrl = locationUrl.split( langList['ja'] )[1].split("?")[0];
  }

  // page URL綺麗にするために配列化
  var locationPageUrlList = locationPageUrl.split('/');

  // 頭の/を除いたパスを格納する配列
  var pageUrlList = [];

  for(var i = 0; i < locationPageUrlList.length; i++){
    // 値が空でなければ、パスを追加
    if( locationPageUrlList[i] !== '') {
      pageUrlList.push(locationPageUrlList[i] );
    }
  }

  // 商品説明を取得
  var pageUrl = pageUrlList.join('/');

  return pageUrl;
}

// 指定された言語にリダイレクト
function redirectLangPage( setLang ) {
  // サイト URL
  var siteUrl = '';

  // リダイレクトするURLとクエリパラメータを取得
  if(setLang == "usd") {
      siteUrl = 'https://hi.mu-mo.com/en';

  } else if(setLang == "eur") {
      siteUrl = 'https://hi.mu-mo.com/fr';

  } else if(setLang == "krw") {
      siteUrl = 'https://hi.mu-mo.com/ko';

  } else if(setLang == "cny") {
      siteUrl = 'https://hi.mu-mo.com/zh';

  } else if(setLang == "twd") {
      siteUrl = 'https://hi.mu-mo.com/zh-hant';

  } else if(setLang == "jpy") {
      siteUrl = 'https://hi.mu-mo.com';

  }

  // 現在開いているページのURLを取得
  var pageUrl = getCurrentPageUrl();

  if( pageUrl !== '' ){
    // リダイレクト先のURL
    var redirectUrl = siteUrl + '/' + pageUrl;

  } else {
    // リダイレクト先のURL
    var redirectUrl = siteUrl;

  }

  //console.log(redirectUrl);

  window.location.href = redirectUrl;

}
